import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { RoutingService } from '@app/core/services/routing.service';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { TransferMethodDetails } from '../models/transfer-method';
import { GetPaidService } from '../services/get-paid.service';

@Injectable({
  providedIn: 'root'
})
export class TransferMethodResolver implements Resolve<any> {
  constructor(private getPaidService: GetPaidService, private routingService: RoutingService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<TransferMethodDetails> {
    return this.getPaidService.getTransferMethodDetails().pipe(
      catchError(error => {
        this.routingService.redirectError(error.status, state.url);
        return of(null);
      })
    );
  }
}
